import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'atx-skeleton-basic',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
  styleUrls: ['./skeleton-basic.component.scss'],
  standalone: false,
})
export class SkeletonBasicComponent {
  @Input()
  public circle: boolean;

  @Input()
  public borderRadius = '0';

  @Input()
  @HostBinding('style.width')
  public width = '100%';

  @Input()
  @HostBinding('style.height')
  public height = 'auto';

  @Input()
  @HostBinding('style.animation-duration')
  public animationDuration = '3s';

  @HostBinding('style.border-radius')
  public get hostBorderRadius() {
    return this.circle ? '50%' : this.borderRadius;
  }
}
